export function scroll(currentY, targetY) {
  let needScrollTop = targetY - currentY;
  let _currentY = currentY;
  setTimeout(() => {
  //  一次调用滑动帧数，每次调用会不一样
    const dist = Math.ceil(needScrollTop/10);
    _currentY += dist;
    window.scrollTo(_currentY, currentY);
    if(needScrollTop > 10 || needScrollTop < -10) {
      scroll(_currentY,targetY);
    } else  {
      window.scrollTo(_currentY, targetY)
    }
  },1)
}

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

export const mallUrl = 'https://mall.yschsz.com/#/shop';
// export const mallUrl = 'https://sdktest.yschsz.com:8003/#/shop';




// WEBPACK FOOTER //
// ./src/assets/js/util.js